/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nocontentreports2Inputs */

const en_nocontentreports2 = /** @type {(inputs: Nocontentreports2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reports`)
};

const de_nocontentreports2 = /** @type {(inputs: Nocontentreports2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Meldungen`)
};

/**
* | output |
* | --- |
* | "No reports" |
*
* @param {Nocontentreports2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nocontentreports2 = /** @type {((inputs?: Nocontentreports2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nocontentreports2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nocontentreports2(inputs)
	return de_nocontentreports2(inputs)
});
export { nocontentreports2 as "noContentReports" }